// extracted by css-extract-rspack-plugin
export default {"option":"ProviderTypePicker-module__option___wGaDq","content":"ProviderTypePicker-module__content___JVKPb"};